"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Big;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _AbstractTextElement = _interopRequireDefault(require("./AbstractTextElement"));

var getClasses = function getClasses(className) {
  return (0, _classNames.default)('private-big', className);
};

function Big(_ref) {
  var className = _ref.className,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["className"]);
  return _react.default.createElement(_AbstractTextElement.default, (0, _extends2.default)({}, rest, {
    className: getClasses(className)
  }));
}

Big.propTypes = (0, _extends2.default)({}, _AbstractTextElement.default.propTypes);
Big.defaultProps = (0, _extends2.default)({}, _AbstractTextElement.default.defaultProps);
Big.displayName = 'Big';
module.exports = exports.default;